// extracted by mini-css-extract-plugin
module.exports = {"reference":"reference_reference__1zR9k","reference-column":"reference_reference-column__3CxHj","item":"reference_item__o9_Eh"};